/* eslint-disable */
// import "../../../../../styles/ComponentsStyles/Financial/Accountant/Dashboard/NetPofitGraph.style.css";
import "../../../../../styles/Pages/Financial/Accountant/Dashboard/NetPofitGraph.style.css";
import { useState } from "react";
import ArrowDown from "../../../../../assets/Icons/Sidebar/ArrowDown.svg";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import LineChartComponent from "./LineChartGraph.components";
import ToggleBtn from "../../../../Universal/ToggleBtn.component";

const NetProfitGraph = ({ graphData }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isCheckedInput, setIsCheckedInput] = useState(false);
  const handleChange = (event) => setSelectedOption(event.target.value);

    const changeButtonStatus = (e) => {
    setIsCheckedInput(e.target.checked);
  };
  return (
    <div className="netProfitGraphComponent">
      <div className="graphHeader">
        <h3>Net Profit</h3>
        <div>
          {/* <ToggleBtn
            name="ebitda"
            type={"radio"}
            label="EBITDA"
            value={"EBITDA"}
            setFieldValue={() => {}}
            // errors={"errors"}
          /> */}
          <div className="toggleBtn">
            <label htmlFor={"ebitda"}>EBITDA</label>
            <input
              type={"checkbox"}
              name={"ebitda"}
              checked={isCheckedInput}
              onChange={changeButtonStatus}
              required
            />
          </div>
        </div>
        <SelectFilter />
      </div>
      <div className="graphContent">
        <div className="LineChart">
          <LineChartComponent data={graphData.lineChartData} />
        </div>
      </div>
    </div>
  );
};

export default NetProfitGraph;
